window.MarketMapLayout = {
    computeMarketMapLinearSectorsVR: function (stocks, width, height, opts) {
        width  = width  !== undefined ? width  : 1000;
        height = height !== undefined ? height : 840;

        const grouped = d3.group(stocks, d => d.sector_id || 'Unknown');
        const sectors = Array.from(grouped, ([sector, items]) => ({
            name: sector,
            children: items,
            total_cap: d3.sum(items, d => d.market_cap || 0)
        }));
        sectors.sort((a, b) => b.total_cap - a.total_cap);

        const bottomIds = new Set(['1', '2', '3', '6', '9', '10', '1959', '1961', '1957', '1963', '1964', '1966']);

        const topRowSectors    = [];
        const bottomRowSectors = [];
        sectors.forEach(s => {
            if (bottomIds.has(String(s.name))) {
                bottomRowSectors.push(s);
            } else {
                topRowSectors.push(s);
            }
        });

        const topCap      = d3.sum(topRowSectors,    s => s.total_cap);
        const bottomCap   = d3.sum(bottomRowSectors, s => s.total_cap);
        const combinedCap = topCap + bottomCap || 1;

        const gap             = (opts && opts.gap          !== undefined) ? opts.gap          : window.MMAP_GAP;
        const availableHeight = Math.max(0, height - gap);

        let splitY = Math.round((topCap / combinedCap) * availableHeight);

        const minRowHeight = height * 0.2;
        if (bottomRowSectors.length > 0 && topRowSectors.length > 0) {
            splitY = Math.max(minRowHeight, Math.min(splitY, height - minRowHeight));
        } else if (bottomRowSectors.length === 0) {
            splitY = height;
        } else if (topRowSectors.length === 0) {
            splitY = 0;
        }

        const topHeight  = splitY;
        const bottomY    = (topRowSectors.length > 0 && bottomRowSectors.length > 0)
            ? (splitY + gap)
            : (topRowSectors.length > 0 ? height : 0);
        const bottomHeight = height - bottomY;

        const sectorNodes = [];
        const allLeaves   = [];

        const paddingInner = (opts && opts.paddingInner !== undefined) ? opts.paddingInner : window.MMAP_PADDING_INNER;
        const paddingOuter = window.MMAP_PADDING_OUTER;

        const computeSubLayout = (sectorList, areaX, areaY, areaWidth, areaHeight) => {
            if (sectorList.length === 0) return;

            sectorList.sort((a, b) => b.total_cap - a.total_cap);
            const listTotalCap  = d3.sum(sectorList, s => s.total_cap) || 1;

            const largest   = sectorList[0];
            const remaining = sectorList.slice(1);

            const minSectorWidth  = 60;
            const minSectorHeight = 60;

            let leftWidth = Math.round((largest.total_cap / listTotalCap) * areaWidth);
            const hasRemaining = remaining.length > 0;
            if (hasRemaining) {
                leftWidth = Math.max(minSectorWidth, Math.min(leftWidth, areaWidth - gap - minSectorWidth));
            } else {
                leftWidth = areaWidth;
            }

            const largestRect = {
                data:      { name: largest.name },
                name:      largest.name,
                x0:        areaX,
                x1:        areaX + leftWidth,
                y0:        areaY,
                y1:        areaY + areaHeight,
                total_cap: largest.total_cap,
                children:  largest.children
            };

            const internalRoot = d3.hierarchy({ children: largest.children })
                .sum(d => d.market_cap || 0)
                .sort((a, b) => (b.value || 0) - (a.value || 0));

            d3.treemap()
                .size([Math.max(1, leftWidth), Math.max(1, areaHeight)])
                .paddingInner(paddingInner)
                .paddingOuter(paddingOuter)
                .tile(d3.treemapSquarify.ratio(1))
                .round(true)(internalRoot);

            internalRoot.leaves().forEach(leaf => {
                allLeaves.push({
                    data:   leaf.data,
                    parent: { data: { name: largest.name } },
                    x0:     leaf.x0 + areaX,
                    x1:     leaf.x1 + areaX,
                    y0:     leaf.y0 + areaY,
                    y1:     leaf.y1 + areaY
                });
            });
            sectorNodes.push(largestRect);

            if (!hasRemaining) return;

            const rightColumnX0    = areaX + leftWidth + gap;
            const rightColumnWidth = Math.max(0, areaWidth - leftWidth - gap);

            const pairs = [];
            for (let i = 0; i < remaining.length; i += 2) {
                const first  = remaining[i];
                const second = remaining[i + 1] || null;
                const pairCap = (first?.total_cap || 0) + (second?.total_cap || 0);
                pairs.push({ first, second, pairCap });
            }

            const availableRightWidth = Math.max(0, rightColumnWidth - gap * Math.max(0, pairs.length - 1));
            const totalPairsCap = Math.max(1, d3.sum(pairs, p => p.pairCap));
            let baseWidths = pairs.map(p => (p.pairCap / totalPairsCap) * availableRightWidth);
            baseWidths = baseWidths.map(w => Math.max(minSectorWidth, w));

            let sumWidths = d3.sum(baseWidths);
            if (sumWidths > availableRightWidth) {
                const overshoot    = sumWidths - availableRightWidth;
                const flexibleIdx  = baseWidths.map((w, i) => (w > minSectorWidth ? i : null)).filter(i => i !== null);
                const totalFlexible = d3.sum(flexibleIdx.map(i => baseWidths[i]));
                if (totalFlexible > 0) {
                    flexibleIdx.forEach(i => {
                        const reduction = (baseWidths[i] / totalFlexible) * overshoot;
                        baseWidths[i] = Math.max(minSectorWidth, baseWidths[i] - reduction);
                    });
                }
            }

            let xOffset = rightColumnX0;

            pairs.forEach((pair, idx) => {
                const colWidth  = baseWidths[idx];
                const yTop      = areaY;
                const pairCap   = Math.max(1, pair.pairCap);
                const topShare  = pair.first ? (pair.first.total_cap / pairCap) : 0;

                let pairTopHeight    = pair.first  ? Math.max(minSectorHeight, topShare * areaHeight) : 0;
                let pairBottomHeight = pair.second ? (areaHeight - pairTopHeight) : 0;

                if (pair.second && pairBottomHeight < minSectorHeight) {
                    pairBottomHeight = minSectorHeight;
                    pairTopHeight    = Math.max(minSectorHeight, areaHeight - pairBottomHeight);
                }

                const buildSector = (s, y0, h) => {
                    if (!s) return;
                    const rect = {
                        data:      { name: s.name },
                        name:      s.name,
                        x0:        xOffset,
                        x1:        xOffset + colWidth,
                        y0,
                        y1:        y0 + h,
                        total_cap: s.total_cap,
                        children:  s.children
                    };

                    const internal = d3.hierarchy({ children: s.children })
                        .sum(d => d.market_cap || 0)
                        .sort((a, b) => (b.value || 0) - (a.value || 0));

                    d3.treemap()
                        .size([Math.max(1, colWidth), Math.max(1, h)])
                        .paddingInner(paddingInner)
                        .paddingOuter(paddingOuter)
                        .tile(d3.treemapSquarify.ratio(1))
                        .round(true)(internal);

                    internal.leaves().forEach(leaf => {
                        allLeaves.push({
                            data:   leaf.data,
                            parent: { data: { name: s.name } },
                            x0:     leaf.x0 + xOffset,
                            x1:     leaf.x1 + xOffset,
                            y0:     leaf.y0 + y0,
                            y1:     leaf.y1 + y0
                        });
                    });
                    sectorNodes.push(rect);
                };

                buildSector(pair.first,  yTop, pairTopHeight);
                buildSector(pair.second, yTop + pairTopHeight, pairBottomHeight);

                xOffset += colWidth + gap;
            });
        };

        if (topRowSectors.length > 0)    computeSubLayout(topRowSectors,    0, 0,       width, topHeight);
        if (bottomRowSectors.length > 0) computeSubLayout(bottomRowSectors, 0, bottomY, width, bottomHeight);

        return { children: sectorNodes, leaves: () => allLeaves };
    },

    convertD3ToAFrameRects: function (leaves, d3Width, d3Height, containerWidth, containerHeight) {
        const scaleX        = containerWidth  / d3Width;
        const scaleY        = containerHeight / d3Height;
        const sizeReduction = window.MMAP_BAR_SCALE; // 1.0

        return leaves.map(d => {
            const centerX = (d.x0 + d.x1) / 2;
            const centerY = (d.y0 + d.y1) / 2;

            const x = centerX * scaleX - containerWidth  / 2;
            const z = containerHeight / 2 - centerY * scaleY;

            const originalWidth = (d.x1 - d.x0) * scaleX;
            const originalDepth = (d.y1 - d.y0) * scaleY;

            const barWidth = originalWidth * sizeReduction;
            const barDepth = originalDepth * sizeReduction;

            return Object.assign({}, d.data, {
                sector:        d.parent.data.name,
                sector_id:     d.parent.data.name,
                x,
                z,
                width:         barWidth,
                depth:         barDepth,
                originalX:     x,
                originalZ:     z,
                originalWidth,
                originalDepth,
                d3x0:          d.x0,
                d3y0:          d.y0,
                d3x1:          d.x1,
                d3y1:          d.y1
            });
        });
    },

    convertD3ToAFrameRectsVR: function (leaves, d3Width, d3Height, containerWidth, containerHeight) {
        return this.convertD3ToAFrameRects(leaves, d3Width, d3Height, containerWidth, containerHeight);
    }
};

window.VRMarketMapLayout = window.MarketMapLayout;
